import React from 'react';
var KitchenSinkComponentMapperContext = /*#__PURE__*/React.createContext();
export default KitchenSinkComponentMapperContext;